import { Box } from '@chakra-ui/react'
import { GreyGrey10, GreyGrey30 } from '@sequencehq/design-tokens'
import { ScheduleTimelinePhases } from './ScheduleTimelinePhases'
import { useAtom } from 'jotai'
import { timelineMonthsAtom } from '../atoms/timeline.atom'
import { useTimelineDimensions } from '../hooks/useTimelineDimensions'
import { ScheduleTimelineProducts } from './ScheduleTimelineProducts'
import { ScheduleTimelineMinimums } from './ScheduleTimelineMinimums'

const MonthMarker = (props: { offset: number }) => {
  return (
    <Box
      position="absolute"
      left={`${props.offset}px`}
      borderLeft={`1px dashed ${GreyGrey30}`}
      height="100%"
      top={0}
    ></Box>
  )
}

export const ScheduleTimelineDataSeries = () => {
  const [timelineMonths] = useAtom(timelineMonthsAtom)
  const { timelineWidth } = useTimelineDimensions()

  return (
    <Box
      position="relative"
      minHeight="100%"
      height="fit-content"
      width={`${timelineWidth}px`}
      backgroundColor={GreyGrey10}
      overflow="hidden"
      pointerEvents="none"
    >
      <ScheduleTimelinePhases />
      <ScheduleTimelineMinimums />
      {/**
       * The background lines
       */}
      {timelineMonths.map(
        (month, idx) =>
          idx > 0 && (
            <MonthMarker offset={month.offset} key={month.date.toString()} />
          )
      )}
      <ScheduleTimelineProducts />
    </Box>
  )
}
